import React from 'react'

const Footer = () => {
  return (
    <div className="footer">
      <p className="footer-text">Created by Johan Löfgren and Marielle Ohlsson</p>
      <p className="footer-text">Icon made by <a href="https://www.cleanpng.com/png-passport-png-61817/">Sheelas</a></p>
      <p className="footer-text">Lottie-animation made by <a href="https://lottiefiles.com/nguyenguyen">Lottiefiles</a></p>
      <p className="footer-text">Worldmap made by <a href="https://www.npmjs.com/package/react-svg-worldmap">Yanivam</a></p>
    </div>
  )
}

export default Footer